import { render, staticRenderFns } from "./drop-payinfo.vue?vue&type=template&id=1855d934&scoped=true&"
import script from "./drop-payinfo.vue?vue&type=script&lang=js&"
export * from "./drop-payinfo.vue?vue&type=script&lang=js&"
import style0 from "./drop-payinfo.vue?vue&type=style&index=0&id=1855d934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855d934",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1855d934')) {
      api.createRecord('1855d934', component.options)
    } else {
      api.reload('1855d934', component.options)
    }
    module.hot.accept("./drop-payinfo.vue?vue&type=template&id=1855d934&scoped=true&", function () {
      api.rerender('1855d934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/drop-payinfo.vue"
export default component.exports